import { atom } from 'recoil'
import PromotionRuleI = Models.PromotionRuleI

export const activeRuleAtom = atom<PromotionRuleI | null>({
    key: 'activeRule',
    default: null,
})
